import React, { useState, useEffect } from "react";
import styles from "./timeSelect.module.scss";
import { toast } from "sonner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClipLoader } from "react-spinners";
import Icon from "../../../components/Icon";
import { timeslots } from "../index";
import { useQuery } from "@tanstack/react-query";
import { getSchedules } from "../../../features/Availability";

interface timesstart {
  starthr: string;
  startmin: string;
}
interface timesend {
  endhr: string;
  endmin: string;
}

interface selectTimeProp {
  startEnd: timeslots[];
  setTimes: React.Dispatch<React.SetStateAction<any>>;
  updateModal: React.Dispatch<React.SetStateAction<boolean>>;
  setTimeId: React.Dispatch<React.SetStateAction<timeslots | undefined>>;
  id: string | null;
  setid: React.Dispatch<React.SetStateAction<string | null>>;
  updateSlot: (index: number) => void;
  pending: boolean;
  pickedDay: any;
}
const SelectTime: React.FC<selectTimeProp> = ({
  setTimes,
  startEnd,
  setTimeId,
  updateModal,
  id,
  setid,
  updateSlot,
  pending,
  pickedDay,
}) => {
  const [fieldIndex, setFieldIndex] = useState(0);
  // const [filteredStart, setFilteredStart] = useState<string[]>([]);
  // const [filteredEnd, setFilteredEnd] = useState<string[]>([]);
  // const [startTime, setStartTime] = useState<timesstart>({
  //   starthr: "",
  //   startmin: "00",
  // });
  // const [endTime, setEndTime] = useState<timesend>({
  //   endhr: "",
  //   endmin: "00",
  // });

  const [selects, setSelects] = useState<timeslots[]>(startEnd);
  // const [timeSet, setTimeSet] = useState(false);

  const hours: string[] = [];
  const minutes: string[] = [];

  for (let i = 0; i < 24; i++) {
    hours.push(i < 10 ? String(i).padStart(2, "0") : String(i));
  }

  for (let x = 0; x < 60; x++) {
    minutes.push(x < 10 ? String(x).padStart(2, "0") : String(x));
  }

  const handleStartTime = (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number
  ) => {
    const { name, value } = e.target;
    setFieldIndex(index);

    let isOverlap = selects.some((item: any) => {
      let starts = item.start.split(":")[0];
      let ends = item.end.split(":")[0];

      return starts < parseInt(value, 10) && parseInt(value, 10) < ends;
    });

    isOverlap &&
      toast.warning(
        `Overlap detected. Please select a different hour that is not between the times you have previously selected`,
        {
          richColors: true,
        }
      );

    setid(selects[index]?.id !== null ? selects[index].id : null);
    setSelects((prev) =>
      prev.map((item: timeslots, i: number) =>
        i === index
          ? {
              ...item,
              id: selects[index]?.id !== null ? selects[index].id : null,
              start:
                name === "starthr"
                  ? !isOverlap
                    ? `${value}:00`
                    : "00:00"
                  : `${item?.start.split(":")[0]}:${value}`,
              end: selects[index].end === "" ? "" : selects[index].end,
            }
          : item
      )
    );
  };

  const handleEndTime = (
    e: React.ChangeEvent<HTMLSelectElement>,
    index: number
  ) => {
    const { name, value } = e.target;
    if (
      parseInt(selects[index].start.split(":")[0], 10) > parseInt(value, 10)
    ) {
      toast.warning("The end hour cannot be smaller than the start hour", {
        richColors: true,
      });
    }
    setid(selects[index]?.id !== null ? selects[index].id : null);
    setSelects((prev) =>
      prev.map((item: timeslots, i: number) =>
        i === index
          ? {
              ...item,
              id: selects[index]?.id !== null ? selects[index].id : null,
              start: item.start,
              end:
                name === "endhr"
                  ? parseInt(item.start.split(":")[0], 10) < parseInt(value, 10)
                    ? `${value}:00`
                    : "00:00"
                  : `${item?.end.split(":")[0]}:${value}`,
            }
          : item
      )
    );

    setTimes(selects);
  };

  useEffect(() => {
    setTimes(selects);
  }, [selects]);

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formatToLocalTime = (utcTime: string, timeZone?: string): string => {
    const date = new Date(utcTime);
    const options: Intl.DateTimeFormatOptions = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone: timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone,
      // Auto-detect if not providedtimeZone ||
    };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };

  const { data: availableTimes } = useQuery({
    queryKey: ["schedules"],
    queryFn: getSchedules,
  });

  useEffect(() => {
    if (availableTimes) {
      setSelects(() => {
        const today = new Date(pickedDay);

        const availableToday = availableTimes?.result.filter((item: any) => {
          return (
            new Date(item?.start).toLocaleDateString() ===
            today.toLocaleDateString()
          );
        });

        if (availableToday.length === 0) {
          return [{ id: null, end: "", start: "" }];
        } else {
          const formattedTimes = availableToday.map((data: any) => {
            const startDate = new Date(data?.start);
            const endDate = new Date(data?.end);

            return {
              id: data?.id,
              start: `${startDate.getHours()}:${startDate
                .getMinutes()
                .toString()
                .padStart(2, "0")}`,
              end: `${endDate.getHours()}:${endDate
                .getMinutes()
                .toString()
                .padStart(2, "0")}`,
            };
          });

          return formattedTimes;
        }
      });
    }
  }, [availableTimes, pickedDay]);

  return (
    <div className={styles.createWrapper}>
      <div className={styles.createBox}>
        {selects &&
          selects?.map((item, index) => {
            return (
              <div className={styles.selection} key={index}>
                <div className={styles.slts}>
                  <label htmlFor="start">Start time</label>
                  <div className={styles.selBoxes}>
                    <select
                      name="starthr"
                      id="start"
                      value={String(item?.start.split(":")[0]).padStart(2, "0")}
                      onChange={(e) => handleStartTime(e, index)}
                    >
                      <option disabled>hr</option>
                      {hours?.map((item, index) => (
                        <option key={index}>{item}</option>
                      ))}
                    </select>
                    <select
                      name="startmin"
                      id="start"
                      value={String(item?.start.split(":")[1]).padStart(2, "0")}
                      onChange={(e) => handleStartTime(e, index)}
                    >
                      <option disabled>min</option>
                      {["00", "30"]?.map((item, index) => (
                        <option key={index}>{item}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className={styles.slts}>
                  <label htmlFor="end">End time</label>
                  <div className={styles.selBoxes}>
                    <select
                      name="endhr"
                      id="end"
                      value={String(item?.end.split(":")[0]).padStart(2, "0")}
                      onChange={(e) => handleEndTime(e, index)}
                    >
                      <option disabled>hr</option>
                      {hours?.map((item, index) => (
                        <option key={index}>{item}</option>
                      ))}
                    </select>
                    <select
                      name="endmin"
                      id="end"
                      value={String(item?.end?.split(":")[1])}
                      onChange={(e) => handleEndTime(e, index)}
                    >
                      <option disabled>min</option>
                      {["00", "30"]?.map((item, index) => (
                        <option key={index}>{item}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className={styles.actionButtons}>
                  {selects[0]?.start === "" && selects[0].end === "" ? null : (
                    <div className={styles.delBtn}>
                      {item?.id !== null ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className={styles.delIcons}
                          onClick={() => {
                            setTimeId(item);
                            updateModal(true);
                          }}
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
                          />
                        </svg>
                      ) : (
                        // </button>
                        <button
                          className={styles.rembtn}
                          onClick={() =>
                            setSelects((prevTimes: any[]) =>
                              prevTimes.filter((_, i) => i !== index)
                            )
                          }
                        >
                          remove
                        </button>
                      )}
                    </div>
                  )}

                  {id === item?.id && id && (
                    <div className={styles.updateBtns}>
                      <button
                        className={styles.editBtns}
                        onClick={() => updateSlot(index)}
                      >
                        {pending ? (
                          <ClipLoader size={30} />
                        ) : (
                          // <Icon name="check" height={10} width={100} />
                          <p>update</p>
                        )}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
      </div>
      <div className={styles.outterBtnContainer}>
        {selects[selects.length - 1].start !== "" && (
          <button
            className={styles.resetBtn}
            onClick={() => setSelects([{ id: null, end: "", start: "" }])}
          >
            Reset
          </button>
        )}
        <button
          className={styles.buttonavailability}
          onClick={() => {
            if (
              selects[selects.length - 1].start !== "" &&
              selects[selects.length - 1].end !== ""
            ) {
              setSelects((prevValues: any) => [
                ...prevValues,
                { id: null, end: "", start: "" },
              ]);
            } else
              toast.warning(
                "Select time for the first Slots before creating another",
                {
                  richColors: true,
                }
              );
          }}
        >
          + add time slot
        </button>
      </div>
    </div>
  );
};

export default SelectTime;
